import { publicFetch } from "./client"
import type { SearchResult } from "./types"

interface GeocodingFeature {
  properties: {
    name?: string
    street?: string
    city?: string
    country?: string
    type?: string
  }
  geometry: { coordinates: [number, number] }
}

export async function searchLocation(query: string, crossCity?: boolean): Promise<SearchResult[]> {
  if (!query || query.length < 2) return []
  try {
    const params = new URLSearchParams({ q: query, limit: "10" })
    if (crossCity) params.set("cross_city", "true")
    const data = await publicFetch<{ features?: GeocodingFeature[] }>(
      `/geo/search?${params.toString()}`,
    )
    if (data.features && Array.isArray(data.features)) {
      return data.features.map((feature) => ({
        name: feature.properties.name || feature.properties.street || "Unknown",
        address: [feature.properties.street, feature.properties.city, feature.properties.country]
          .filter(Boolean)
          .join(", "),
        latitude: feature.geometry.coordinates[1],
        longitude: feature.geometry.coordinates[0],
        type: feature.properties.type,
      }))
    }
    return []
  } catch (error) {
    console.error("Location search error:", error)
    return []
  }
}

export async function reverseGeocode(lat: number, lon: number): Promise<string> {
  try {
    const data = await publicFetch<{ display_name?: string; address?: { road?: string } }>(
      `/geo/reverse?lat=${lat}&lon=${lon}`,
    )
    return data.display_name || data.address?.road || `${lat.toFixed(4)}, ${lon.toFixed(4)}`
  } catch (error) {
    console.error("Reverse geocode error:", error)
    return `${lat.toFixed(4)}, ${lon.toFixed(4)}`
  }
}
